import React from 'react';
import { FieldArray } from 'redux-form';
import PropTypes from 'prop-types';

import FormSection from 'containers/FormSectionContainer';
import FormField from 'containers/FormField';
import FieldSet from 'containers/FieldSetContainer';
import ConditionalSection from 'containers/ConditionalSection';
import RadioButtonGroup from 'components/RadioButtonGroup';
import Datepicker from 'components/Datepicker';
import SelectField from 'components/SelectField';
import TextFieldBox from 'components/TextFieldBox';
import TextFieldArea from 'components/TextFieldArea';

import FormProvider from 'routes/Documents/containers/FormProvider';

import { fieldIs } from 'lib/conditions';

import MedicationEvents from './MedicationEvents';

const amounts = [
  { value: '1', label: 'medication.amount.1' },
  { value: '2', label: 'medication.amount.2' },
  { value: '3', label: 'medication.amount.3' },
  { value: '4', label: 'medication.amount.4' },
  { value: '5', label: 'medication.amount.5' },
  { value: '6', label: 'medication.amount.6' },
  { value: '7', label: 'medication.amount.7' },
  { value: '8', label: 'medication.amount.8' },
];

const intervals = [
  { value: '1', label: 'medication.interval.1' },
  { value: '2', label: 'medication.interval.2' },
  { value: '3', label: 'medication.interval.3' },
  { value: '4', label: 'medication.interval.4' },
  { value: '5', label: 'medication.interval.5' },
  { value: '6', label: 'medication.interval.6' },
  { value: '7', label: 'medication.interval.7' },
  { value: '8', label: 'medication.interval.8' },
];

const VitaminForm = props => (
  <FormProvider {...props}>
    <FormSection localeId="medication.sections.vitamin">
      <FieldSet localeId="medication.labels.vitamin">
        <FormField name="vitamin" component={TextFieldBox} hintLocale="medication.hints.vitamin" />
      </FieldSet>
      <FieldSet localeId="medication.labels.vitaminCompany">
        <FormField name="vitaminCompany" component={TextFieldBox} hintLocale="medication.hints.vitaminCompany" />
      </FieldSet>
      <FieldSet localeId="medication.labels.vitaminDosage">
        <FormField name="vitaminDosage" component={TextFieldBox} hintLocale="medication.hints.vitaminDosage" />
      </FieldSet>
      <FieldSet localeId="medication.labels.vitaminOtherInfo">
        <FormField
          name="vitaminOtherInfo"
          component={TextFieldArea}
          hintLocale="medication.hints.vitaminOtherInfo"
          rows="3"
          viewStyle={{ width: '25rem' }}
        />
      </FieldSet>
    </FormSection>
    <FormSection localeId="medication.sections.vitamin.usageType">
      <FieldSet localeId="medication.labels.vitamin.usageType">
        <FormField
          name="usageType"
          component={RadioButtonGroup}
          options={[
            { value: 'regular', label: 'medication.opts.regular' },
            { value: 'asNeeded', label: 'medication.opts.asNeeded' },
          ]}
        />
      </FieldSet>
      <ConditionalSection condition={fieldIs('usageType', 'regular')}>
        <FieldSet localeId="medication.labels.amount">
          <FormField name="amount" component={SelectField} hintLocale="medication.hints.amount" options={amounts} />
        </FieldSet>
        <FieldSet localeId="medication.labels.interval">
          <FormField
            name="interval"
            component={SelectField}
            hintLocale="medication.hints.interval"
            options={intervals}
          />
        </FieldSet>
        <FieldSet>
          <FormField
            name="intervalType"
            component={SelectField}
            hintLocale="medication.hints.intervalType"
            options={[
              { value: 'daily', label: 'medication.interval.daily' },
              { value: 'weekly', label: 'medication.interval.weekly' },
              { value: 'monthly', label: 'medication.interval.monthly' },
              { value: 'yearly', label: 'medication.interval.yearly' },
            ]}
          />
        </FieldSet>
      </ConditionalSection>
    </FormSection>
    <FormSection localeId="medication.sections.startAndEndDate">
      <FieldSet localeId="medication.labels.vitamin.start">
        <FormField name="start" component={Datepicker} />
      </FieldSet>
      <FieldSet localeId="medication.labels.vitamin.medicationHasEnded">
        <FormField name="hasEnded" component={RadioButtonGroup} preset="yesno" />
      </FieldSet>
      <ConditionalSection condition={fieldIs('hasEnded', 'yes')}>
        <FieldSet localeId="medication.labels.vitamin.end">
          <FormField name="end" component={Datepicker} dateFloorHook="start" />
        </FieldSet>
      </ConditionalSection>
    </FormSection>
    <FormSection localeId="medication.sections.eventsDuringUse">
      {props.editing && <FieldArray name="events" component={MedicationEvents} />}
      {!props.editing && <MedicationEvents fields={props.formValues.events} view />}
    </FormSection>
  </FormProvider>
);

export default VitaminForm;

VitaminForm.propTypes = {
  editing: PropTypes.bool,
  formValues: PropTypes.object,
};
